import styled from 'styled-components'

export const Table = styled.table`
  width: ${({ width }) => width || '100%'};
  margin: 0 auto;
  border-collapse: separate;
  border-spacing: 0;
  background: ${props => props.theme.colors.background.primary};
  border-radius: ${props => props.theme.radius.input};
  overflow: hidden;
  border: 1px solid ${props => props.theme.colors.border.medium};
  box-shadow: 0 1px 2px ${props => props.theme.colors.shadow.light};
  transition: all 0.3s ease;
`

export const Thead = styled.thead`
  background: ${props => props.theme.colors.semantic.primary};
  color: ${props => props.theme.colors.text.inverse};
  transition: all 0.3s ease;

  td {
    padding: ${({ compact }) => compact ? '0.15rem 0.25rem' : '0.2rem 0.35rem'};
    font-weight: 600;
    font-size: 0.875rem;
    font-family: ${props => props.theme.typography.fontFamily};
    letter-spacing: 0.005em;
    text-transform: uppercase;
    border: none;
    white-space: nowrap;

    &:first-child {
      border-top-left-radius: 5px;
    }

    &:last-child {
      border-top-right-radius: 5px;
    }
  }
`

export const Tbody = styled.tbody`
  tr {
    transition: background 0.2s ease;

    &:hover {
      background: ${props => props.theme.colors.background.hover};
    }

    &:last-child td {
      border-bottom: none;
    }
  }
`

export const Trow = styled.tr`
  background: ${props => props.theme.colors.background.primary};
  transition: background 0.3s ease;

  td {
    border-bottom: 1px solid ${props => props.theme.colors.border.medium};
    transition: border-color 0.3s ease;
  }
`

export const Tcol = styled.td`
  padding: ${({ compact }) => compact ? '0.2rem 0.35rem' : '0.25rem 0.5rem'};
  text-align: ${({ align }) => align || 'center'};
  color: ${props => props.theme.colors.text.secondary};
  font-size: 1rem;
  font-weight: 400;
  font-family: ${props => props.theme.typography.fontFamily};
  vertical-align: middle;
  line-height: 1.1;
  transition: color 0.3s ease;

  &:has(svg) {
    cursor: pointer;
  }

  svg {
    transition: all 0.2s ease;

    &:hover {
      transform: scale(1.15);
      color: ${props => props.theme.colors.text.primary};
    }
  }
`
